import { memo, useContext } from "react";
import { FormattedMessage } from "react-intl";
import LookAlikeProduct from "app/pages/.shared/LookAlikeProduct/LookAlikeProduct";
import RelativeLink from "app/pages/.shared/RelativeLink";
import PropTypes from "prop-types";
import { productShape } from "app/utils/propTypes";
import "./LookAlikeSearchContent.scss";
import { OFFER_CONTRACT_TYPES } from "app/constants";
import { sendTagOnLookAlikeProductClick } from "app/utils/analytics";
import { generateDestinationTitle, generateHotelName } from "app/utils/productUtils";
import { containsTrainTransportationTypes } from "app/utils/utils";
import AppGlobalsContext from "app/AppGlobalsContext";

const LookAlikeSearchContent = ({ products = [] }) => {
	const { shop } = useContext(AppGlobalsContext);

	return (
		<div className="lookalike-search-products">
			<div className="lookalike-search-products__label">
				<FormattedMessage id="product.deal.expired.lookalike.products.label" />
			</div>

			<div className="lookalike-search-products__list">
				{products?.length > 0 && (
					<div className="lookalike-search-products__title">
						<FormattedMessage id="lookalike.products.title" />
						{" :"}
					</div>
				)}

				{products?.map((product, index) => {
					return (
						<div key={product.id} className="lookalike-search-products__item">
							<LookAlikeProduct
								key={product.id}
								isRental={product?.contractType === OFFER_CONTRACT_TYPES.RENTAL}
								onClick={() =>
									sendTagOnLookAlikeProductClick({
										productUri: product.uri,
										position: index + 1,
									})
								}
								uri={product.uri}
								image={{
									src: product?.photos?.[0]?.url,
									thumbnail: product?.photos?.[0]?.thumbnail,
								}}
								title={generateDestinationTitle(shop, product)}
								subtitle={generateHotelName(product?.name, product?.category)}
								tripAdvisor={{
									id: product?.tripadvisor?.id,
									rating: product?.tripadvisor?.rating,
									reviewsCount: product?.tripadvisor?.reviewsCount,
								}}
								startingPrice={Number(product?.fromPriceType?.value) || 0}
								price={Number(product?.fromPriceType?.publicPrice) || 0}
								offerPriceType={product?.fromPriceType?.type}
								nbOfNights={product?.fromPriceType?.numberOfNights}
								includeFlightOption={product?.includeOfferWithFlight}
								includeTrainOption={containsTrainTransportationTypes(
									product?.transportationTypes
								)}
							/>
						</div>
					);
				})}
			</div>
			<div className="lookalike-search-products__button">
				<RelativeLink
					to={{ pathname: "/listing" }}
					className="lookalike-search-products__cta"
					variant="primary"
					data-testid="lookalike-search-products-cta"
				>
					<FormattedMessage id="merchandising.footer.redirect.cta.text" />
				</RelativeLink>
			</div>
		</div>
	);
};

LookAlikeSearchContent.propTypes = {
	products: PropTypes.arrayOf(productShape),
};

export default memo(LookAlikeSearchContent);
